import { useMutation, useQuery, useQueryClient } from "react-query";
import AxiosPrivate from "../functions/axios/axiosPrivate";
import axios from "../functions/axios/axios";
import { notify } from "../components/Toast";

export const useGetStores = (restaurant_id) => {
  const result = useQuery(["getStores", restaurant_id], () =>
    axios
      .get(`/inventory/branch-warehouses/${restaurant_id}`)
      .then((res) => res.data)
  );

  return {
    ...result,
    stores: result.data,
  };
};

export const useCreateStore = (restaurant_id) => {
    const queryClient = useQueryClient();
  
    return useMutation(
      (formData) =>
        AxiosPrivate({
          url: `/inventory/warehouses/`,
          method: "POST",
          data: formData,
        }),
      {
        onSuccess: () => {
          queryClient.invalidateQueries("getStores");
          notify("Store created successfully", "success")
        },
        onError: (err) => {
            notify(err.message, "error")
        },
      }
    );
  };


export const useGetUnits = (restaurant_id) => {
  const result = useQuery(["getUnits", restaurant_id], () =>
    axios
      .get(`/inventory/branch-units/${restaurant_id}`)
      .then((res) => res.data)
  );

  return {
    ...result,
    units: result?.data?.units,
  };
};


export const useCreateUnits = () => {
    const queryClient = useQueryClient();
  
    return useMutation(
      (formData) =>
        AxiosPrivate({
          url: `/inventory/create-units/`,
          method: "POST",
          data: formData,
        }),
      {
        onSuccess: () => {
          queryClient.invalidateQueries("getUnits");
          notify("Unit created successfully", "success")
        },
        onError: (err) => {
            notify(err.message, "error")
        },
      }
    );
  };
export const useEditBranch = () => {
    const queryClient = useQueryClient();
  
    return useMutation(
      (formData) =>
        AxiosPrivate({
          url: `/restaurant/branch-detail/${formData.id}/`,
          method: "POST",
          data: formData,
        }),
      {
        onSuccess: () => {
          queryClient.invalidateQueries("getBranches");
          notify("Branch edited successfully", "success")
        },
        onError: (err) => {
            notify(err.message, "error")
        },
      }
    );
  };